import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import TextType from "../../components/TypeWriter/TextType";
import GoogleLogin from "react-google-login";
import { XANO_GOOGLE_CLIENT_ID } from "../../config/api_config";
import useWindowSize from "../../hooks/useWindowSize";
import useInView from "../../hooks/useInView";

const companies = [
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Companies/Frame%20427322567%20(1).png",
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Companies/Frame%20427322567-1.png",
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Companies/Frame%20427322567-2.png",
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Companies/Frame%20427322567-3.png",
  "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Companies/Frame%20427322567-4.png",
];
export const AnimatedCompanyBadge = () => {
  const [companyIndex, setCompanyIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCompanyIndex((prev) => (prev + 1) % companies.length);
    }, 1500);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="absolute top-[30%] left-[30%] h-[36px] w-[36px] overflow-hidden md:h-[48px] md:w-[48px]">
      <AnimatePresence mode="wait">
        <motion.img
          key={companies[companyIndex]}
          src={companies[companyIndex]}
          alt=""
          className="h-full w-full"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        />
      </AnimatePresence>
    </div>
  );
};

const Lcp = ({
  authResponse,
  handleLinkedInLogin,
  navigateLinkedInLogin,
  onStickyBarVisibilityChange,
  viewRef,
  handleScroll,
}) => {
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const { width } = useWindowSize();

  // Use the custom useInView hook for better intersection observer management
  const { ref: stickyBarRef, isInView } = useInView({
    threshold: [0, 0.1, 1], // Multiple thresholds for better detection
    rootMargin: "-10px 0px", // Trigger slightly before element is completely out of view
  });

  // Effect to handle visibility changes
  useEffect(() => {
    console.log("Sticky bar visibility changed:", isInView);
    if (onStickyBarVisibilityChange) {
      onStickyBarVisibilityChange(isInView);
    }
  }, [isInView, onStickyBarVisibilityChange]);

  return (
    <div className="mt-9 w-full md:mt-[90px]">
      {window.innerWidth < 768 && (
        <div className="w-full px-2">
          <div className="relative w-full">
            {/* Invisible final text to reserve exact space and avoid CLS */}
            <div className="invisible text-center leading-[120%] tracking-normal">
              <div
                className={`flex w-full  flex-col gap-3 text-center leading-[120%] ${
                  width <= 320 ? "text-[20px]" : "text-[24px]"
                }`}
              >
                <span className="inline font-medium  leading-[120%] tracking-normal text-white">
                  Build Your Dream Career By{" "}
                </span>
                <div
                  className={`py-2 font-bold leading-[120%] ${
                    width <= 320 ? "text-[22px]" : "text-[26px]"
                  }`}
                  style={{
                    backgroundImage: `linear-gradient(to right,
  rgba(64,106,255,0) 0%,
  rgba(38,68,149,0.5) 50%,
  rgba(64,106,255,0) 100%
)`,
                  }}
                >
                  <span
                    className={`inline ${
                      width <= 320 ? "text-[22px]" : "text-[26px]"
                    } font-bold leading-[120%] tracking-normal text-white`}
                  >
                    Accelerating Promotion
                  </span>
                </div>
                <span className="font-medium leading-[120%] text-white">
                  In Under 2 Months
                </span>
              </div>
            </div>
            {/* Absolutely positioned typing text overlay */}
            <div className="absolute inset-0 flex items-start justify-start text-center">
              <div
                className={`flex w-full  flex-col gap-3 text-center leading-[120%] ${
                  width <= 320 ? "text-[20px]" : "text-[24px]"
                }`}
              >
                <span className="inline font-medium  leading-[120%] tracking-normal text-white">
                  Build Your Dream Career By{" "}
                </span>
                <div
                  className={`py-2 font-bold leading-[120%] ${
                    width <= 320 ? "text-[22px]" : "text-[26px]"
                  }`}
                  style={{
                    backgroundImage: `linear-gradient(to right,
  rgba(64,106,255,0) 0%,
  rgba(38,68,149,0.5) 50%,
  rgba(64,106,255,0) 100%
)`,
                  }}
                >
                  <TextType
                    text={[
                      "Landing A Job",
                      "Accelerating Promotion",
                      "Switching Your Path",
                      "Learning Core Skills",
                    ]}
                    typingSpeed={75}
                    pauseDuration={2000}
                    deletingSpeed={30}
                    loop={true}
                    showCursor={true}
                    cursorCharacter="|"
                    className="inline"
                    textClassName="tracking-normal bg-[linear-gradient(to_right,white_0%,#FFE994_100%)] bg-clip-text text-transparent"
                    cursorClassName="text-[#FFE994]"
                    skipDeletion={true}
                  />
                </div>
                <span className="font-medium leading-[120%] text-white">
                  In Under 2 Months
                </span>
              </div>
            </div>
          </div>
          <div className="relative mt-8 w-full">
            <img
              alt=""
              className="h-auto w-full"
              src="https://img.learntube.ai/public-assets/LandingPage-2025/Frame%20427322649.webp"
            />
            <div className="absolute bottom-[20%] right-[5%]  h-[90px] w-[90px] md:h-[120px] md:w-[120px] ">
              <div className="relative h-full w-full">
                <img
                  alt="badge"
                  src="https://img.learntube.ai/public-assets/LandingPage-2025/Group%2023588.webp"
                  className="h-full w-full"
                />
                <AnimatedCompanyBadge />
              </div>
            </div>
          </div>
          <div
            className="mt-8 flex w-full flex-col items-center justify-center"
            ref={stickyBarRef}
          >
            <GoogleLogin
              clientId={XANO_GOOGLE_CLIENT_ID}
              render={(renderProps) => {
                return (
                  <div
                    className="btn--glow h-12 w-full rounded-lg"
                    style={{
                      boxShadow: "0px 0px 10px 0px rgba(127, 194, 65, 0.35)",
                    }}
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled}
                  >
                    {false ? (
                      <button className="py-auto flex  h-full w-full w-full items-center justify-center gap-2.5 self-stretch rounded-lg bg-[#7fc241] ">
                        <div className="flex items-center justify-center gap-2 ">
                          <span className="h-3 w-3 animate-bigbounce rounded-full bg-light_green [animation-delay:0ms]"></span>
                          <span className="h-3 w-3 animate-bigbounce rounded-full bg-light_green [animation-delay:150ms]"></span>
                          <span className="h-3 w-3 animate-bigbounce rounded-full bg-light_green [animation-delay:300ms]"></span>
                        </div>
                      </button>
                    ) : (
                      <button className="flex h-full w-full items-center justify-center gap-2 rounded-lg  bg-[#7FC241] py-[10px] text-center text-[18px] font-semibold text-[#121212]">
                        <div className="h-7 w-7 rounded-full bg-white">
                          <img
                            src="https://img.learntube.ai/public-assets/Onboarding_Revamp/image%20479.png?updatedAt=1694429827511"
                            width={28}
                            height={28}
                            alt="google icon"
                          />
                        </div>{" "}
                        Start Learning For Free
                      </button>
                    )}
                  </div>
                );
              }}
              onSuccess={(e) => authResponse(e, setIsGoogleLoading)}
              onFailure={(e) => authResponse(e, setIsGoogleLoading)}
              cookiePolicy={"single_host_origin"}
            />

            <div
              className="mt-1 text-center text-center text-[12px] font-semibold text-[#83BEFF]"
              ref={viewRef}
            >
              <img
                alt=""
                src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Frame%20152.png"
                width={38}
                height={20}
                className="mr-1 inline-block"
              />
              1,705 Learners Started Their Journey Today
            </div>
          </div>
        </div>
      )}

      {window.innerWidth >= 768 && (
        <div className="flex w-full items-center justify-between">
          <div className="flex w-[542px] flex-col items-start justify-start">
            <div className="relative flex w-full flex-col items-start justify-center text-left">
              {/* Invisible final text to reserve exact space and avoid CLS */}
              <div className="invisible text-left leading-[120%]">
                <div className="flex flex-col gap-3 text-left text-[44px] font-semibold leading-[120%]">
                  <span className="inline font-medium  leading-[120%] tracking-normal text-white">
                    Build Your Dream Career By{" "}
                  </span>
                  <div
                    className="py-2"
                    style={{
                      backgroundImage: `linear-gradient(to right,
  rgba(64,106,255,0) 0%,
  rgba(38,68,149,0.5) 50%,
  rgba(64,106,255,0) 100%
)`,
                    }}
                  >
                    <span className="inline text-[44px] font-semibold leading-[120%] tracking-normal text-white">
                      Fast-Tracking Your Promotion
                    </span>
                  </div>
                  <span className="inline font-medium  leading-[120%] tracking-normal text-white">
                    In Under 2 Months
                  </span>
                </div>
              </div>
              {/* Absolutely positioned typing text overlay */}
              <div className="absolute inset-0 flex items-start justify-start">
                <div className="flex flex-col gap-3 text-left text-[44px] font-semibold leading-[120%]">
                  <span className="inline font-medium  leading-[120%] tracking-normal text-white">
                    Build Your Dream Career By{" "}
                  </span>
                  <div
                    className="py-2"
                    style={{
                      backgroundImage: `linear-gradient(to right,
  rgba(64,106,255,0) 0%,
  rgba(38,68,149,0.5) 50%,
  rgba(64,106,255,0) 100%
)`,
                    }}
                  >
                    <TextType
                      text={[
                        "Landing A Job",
                        "Accelerating Promotion",
                        "Switching Your Path",
                        "Learning Core Skills",
                      ]}
                      typingSpeed={75}
                      pauseDuration={2000}
                      deletingSpeed={30}
                      loop={true}
                      showCursor={true}
                      cursorCharacter="|"
                      className="inline"
                      textClassName="tracking-normal bg-[linear-gradient(to_right,white_0%,#FFE994_100%)] bg-clip-text text-transparent"
                      cursorClassName="text-[#DED996]"
                      skipDeletion={true}
                    />
                  </div>
                  <span className="inline font-medium  leading-[120%] tracking-normal text-white">
                    In Under 2 Months
                  </span>
                </div>
              </div>
            </div>
            <div
              className="mt-[84px] flex w-full flex-col items-start justify-start"
              ref={viewRef}
            >
              <div className="self-center text-center text-[16px] font-medium italic text-[#D5EDFF]">
                <img
                  alt=""
                  src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Frame%20152.png"
                  width={38}
                  height={20}
                  className="mr-1 inline-block"
                />
                1,705 Started Learning Today for{" "}
                <span className="font-bold text-[#83BEFF]"> FREE</span>
              </div>
              <div
                className="flex w-full flex-1  flex-col items-center justify-start gap-3"
                ref={stickyBarRef}
              >
                <GoogleLogin
                  clientId={XANO_GOOGLE_CLIENT_ID}
                  render={(renderProps) => {
                    return (
                      <div
                        className="btn--glow mt-2 h-[52px] w-full rounded-lg"
                        style={{
                          boxShadow:
                            "0px 0px 10px 0px rgba(127, 194, 65, 0.35)",
                        }}
                        onClick={renderProps.onClick}
                        disabled={renderProps.disabled}
                        tabIndex={-1}
                      >
                        {false ? (
                          <button
                            className=" flex  h-full w-full w-full items-center justify-center gap-2.5 self-stretch rounded-lg bg-[#7fc241] "
                            tabIndex={-1}
                          >
                            <div className="flex items-center justify-center gap-2 ">
                              <span className="h-3 w-3 animate-bigbounce rounded-full bg-light_green [animation-delay:0ms]"></span>
                              <span className="h-3 w-3 animate-bigbounce rounded-full bg-light_green [animation-delay:150ms]"></span>
                              <span className="h-3 w-3 animate-bigbounce rounded-full bg-light_green [animation-delay:300ms]"></span>
                            </div>
                          </button>
                        ) : (
                          <button
                            className=" flex h-full w-full items-center justify-center gap-2 rounded-lg  bg-[#7FC241] text-center text-[18px] font-bold text-[#121212]"
                            tabIndex={-1}
                          >
                            <div className="h-7 w-7 rounded-full bg-white">
                              <img
                                src="https://img.learntube.ai/public-assets/Onboarding_Revamp/image%20479.png?updatedAt=1694429827511"
                                width={28}
                                height={28}
                                alt="google icon"
                              />
                            </div>{" "}
                            Sign In With Google
                          </button>
                        )}
                      </div>
                    );
                  }}
                  onSuccess={(e) => authResponse(e, setIsGoogleLoading)}
                  onFailure={(e) => authResponse(e, setIsGoogleLoading)}
                  cookiePolicy={"single_host_origin"}
                />
                <div
                  className=" py-auto flex h-[52px] w-full cursor-pointer items-center justify-center gap-2 rounded-lg border-[1px] border-[#7FC241] text-center font-semibold text-[#7FC241] "
                  onClick={navigateLinkedInLogin}
                  tabIndex={-1}
                >
                  <div className="h-7 w-7 rounded-full">
                    <img
                      src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/logos_linkedin-icon.svg"
                      width={28}
                      height={28}
                      alt="google icon"
                    />
                  </div>
                  <p
                    className="text-center text-[18px] font-semibold text-[#7FC241] "
                    tabIndex={-1}
                  >
                    Sign In With LinkedIn
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative flex w-[540px] flex-col items-start justify-start">
            <img
              alt=""
              className="h-full w-full"
              src="https://img.learntube.ai/public-assets/LandingPage-2025/hero-illustration.webp"
            />
            <div className="absolute bottom-[20%] right-[10%] h-[120px] w-[120px]">
              <div className="relative h-full w-full">
                <img
                  alt="badge"
                  src="https://img.learntube.ai/public-assets/LandingPage-2025/Group%2023588.webp"
                  className="h-full w-full"
                />
                <AnimatedCompanyBadge />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Lcp;
